<template>
  <PreAuthPage>
    <div class="sh-card__head">
      <LogoTile :branding="branding" :alt="tenantName" :size="44" />
      <span class="noaccess__badge"><v-icon size="20" color="warning">block</v-icon></span>
      <h1 class="sh-card__title">No access to {{ tenantName }}</h1>
      <p class="sh-card__subtitle">
        Your account is signed in, but it is not part of this app. Ask an administrator to add your organisation.
      </p>
      <!-- The one fact that resolves most "no access" tickets on the spot:
           which account this is. Two-account users land here constantly. -->
      <p v-if="email" class="sh-whoami">Signed in as <b>{{ email }}</b></p>
    </div>

    <!-- Sign-out clears the Auth0 session too, so the next "Sign in" asks
         for credentials — that is what "different account" means here. -->
    <v-btn class="noaccess__switch" color="primary" variant="flat" block @click="session.signOut()"
      >Sign in with a different account</v-btn
    >
    <v-btn
      v-if="support"
      class="noaccess__support"
      :href="support"
      :target="support.startsWith('mailto:') ? undefined : '_blank'"
      rel="noopener noreferrer"
      variant="text"
      size="small"
      block
      >Contact support</v-btn
    >
  </PreAuthPage>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useSessionStore } from "@/stores/session";
import { supportHref } from "@/tenant/loginLinks";
import LogoTile from "@/shell/LogoTile.vue";
import PreAuthPage from "@/shell/PreAuthPage.vue";

export default defineComponent({
  name: "NoAccess",
  components: { LogoTile, PreAuthPage },
  setup() {
    const session = useSessionStore();
    const tenantName = computed(() => session.tenant?.name || "Metaship");
    const branding = computed(() => session.tenant?.branding ?? null);
    const email = computed(() => session.user?.email || null);
    const support = computed(() => supportHref(session.tenant?.loginPage));
    return { session, tenantName, branding, email, support };
  },
});
</script>

<style scoped>
.noaccess__badge {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(var(--v-theme-warning), 0.14);
}
.noaccess__switch {
  font-weight: 600;
}
.noaccess__support {
  margin-top: 8px;
  font-size: 12px;
  color: var(--sh-text-60);
}
</style>
